import React, {useState, useEffect} from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import MobileStepper from '@material-ui/core/MobileStepper';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import {thumborImageUrl} from '../../Utility';
const AutoPlaySwipeableViews = SwipeableViews
// autoPlay(SwipeableViews);

const useStyles = makeStyles(theme => ({
  root: {
    // maxWidth: 400,
    flexGrow: 1,
  },
  img: {
    height: 'calc(100vh - 80px)',
    // maxHeight: '55vh',
    display: 'block',
    // maxWidth: 400,
    overflow: 'hidden',
    width: '100%',
    objectFit: 'cover',
    [theme.breakpoints.down('sm')]: {
      height: 'calc(50vh - 40px)',
    }
  },
  carouselWrapper: {
    // display: 'flex',
    '&> div': {
      // display: 'flex'
      height: '100%'
    },
    // '& img': {
    //   display: 'flex',
    //   objectFit: 'contain',
    //   height: '100%'
    // }
  },
  stepper: {
    background: 'transparent',
    // webkitBackdropFilter: 'blur(37px)',
    // backdropFilter: 'blur(37px)',
    position: 'absolute',
    bottom: 0,
    left: '50%',
    transform: 'translateX(-50%)',
  },
  leftCarouselIcon: {
    background: 'transparent',
    position: 'absolute',
    top: '50%',
    left: 0,
    fontSize: 50,
    color: 'white',
    cursor: 'pointer'
  },
  rightCarouselIcon: {
    background: 'transparent',
    position: 'absolute',
    top: '50%',
    right: 0,
    fontSize: 50,
    color: 'white',
    cursor: 'pointer'
  },
  stepperDotActive: {
    backgroundColor: `${theme.palette.primary.main} !important`
  },
  stepperDot: {
    backgroundColor: 'white'
  },
  iconDisabled: {
    color: 'grey'
  }
}));

function SwipeableTextMobileStepper({title = "", images: imagesData = []}) {
  let [images, setImages] = useState([]);
  let [renderCounter, setRenderCounter] = useState(1);
  const classes = useStyles();
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);

  const maxSteps = images.length;

  useEffect(() => {
    if(imagesData && imagesData.length > 0) {
      setImages(imagesData.filter((item) => {
        if(!item) return false;
        else return true;
      }))
    }
  }, [imagesData])

  const handleNext = () => {
    if(activeStep === maxSteps - 1) return;
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  const handleBack = () => {
    if(activeStep === 0) return;
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleStepChange = step => {
    setActiveStep(step);
  };

  const handleImageLoadError = () => {
  //   devConsolelog('carousel images image error ', images);
  //   // setTimeout(() => {
  //   //   if(images.length > 0) {
  //   //     setImages(images.map(item => `${TRAVCLAN_LOGO}`));
  //   //     setRenderCounter(++renderCounter)
  //   //   }
  //   // }, 100)
   }

  // devConsolelog('carousel images ', images, renderCounter)

  // useEffect(() => {
  //   if(!images || images.length <= 0) setImages([`${TRAVCLAN_LOGO}`])
  // }, [])

  // return (<Typography variant="h6" color="textSecondary">No images found!</Typography>)
  return (
    <div className={classes.root}>
      <AutoPlaySwipeableViews
        key={renderCounter}
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
        resistance={true}
        slideClassName={classes.carouselWrapper}
      >
        {
          images.map((step, index) => {
            if(!step) return null;
            if(typeof step == 'object') {
              step = step.file
            }
            return (<div key={index}>
              {Math.abs(activeStep - index) <= 2 ? (
                <img className={classes.img} src={thumborImageUrl(step, 0, 500)} alt={title} onError={handleImageLoadError}/>
              ) : null}
            </div>)
          })
        }
      </AutoPlaySwipeableViews>
      <MobileStepper
        steps={maxSteps}
        position="static"
        variant="dots"
        activeStep={activeStep}
        classes={{root: classes.stepper, dotActive: classes.stepperDotActive, dot: classes.stepperDot}}
      />
      <div>
        <KeyboardArrowLeft className={`${classes.leftCarouselIcon} ${activeStep === 0 && classes.iconDisabled}`} onClick={handleBack} disabled={activeStep === 0}/>
      </div>
      <div>
        <KeyboardArrowRight className={`${classes.rightCarouselIcon} ${activeStep === maxSteps - 1 && classes.iconDisabled}`} onClick={handleNext} disabled={activeStep === maxSteps - 1} />
      </div>
    </div>
  );
}


export default SwipeableTextMobileStepper;
